// SN maturity payoff (Regime B) — directional planning mechanic.
// Note carries at the FMV freeze rate; at maturity it credits the plan base
// rate compounded over the tenor, on top of the converted value.
export function snCreditMultiple({ baseRate, tenorYears }) {
  return Math.pow(1 + baseRate, tenorYears) - 1; // e.g. 7%/7yr -> 0.606
}
export function snMaturityBumps(scn, conversionRows) {
  const bumps = {};
  if (!scn.snPayoff) return bumps;
  const baseRate = Number(scn.snBaseRate ?? 7) / 100;
  const tenor = Number(scn.snTenor ?? 7);
  const matLag = Number(scn.snMatLag ?? 2);
  const noteOffset = Number(scn.snNoteStartOffset ?? 2);
  const credit = snCreditMultiple({ baseRate, tenorYears: tenor });
  conversionRows.forEach((row, i) => {
    if (i >= noteOffset && Number(row.conversion) > 0) {
      const matAge = Number(row.age) + matLag;
      bumps[matAge] = (bumps[matAge] || 0) + Number(row.conversion) * credit;
    }
  });
  return bumps;
}
